
<div class="mat-table">
  <div *ngIf="userForm" class="table_principal">
    <form [formGroup]="userForm">
      <table #table mat-table matSort [dataSource]="matDataSource" formArrayName="droitsDTO" (matSortChange)="sortData($event)">
        <caption>Liste des droits</caption>
        <ng-container matColumnDef="commerce">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="centrer"> Commerce </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('commerce').value" (change)="element.get('commerce').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="fraisGeneraux">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="centrer"> Frais Généraux </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('fraisGeneraux').value" (change)="element.get('fraisGeneraux').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="exploitation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="centrer"> Exploitation </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            {{ element.get('idLigneTableau').setValue(i + 1) }}
            <mat-checkbox [checked]="element.get('exploitation').value" (change)="element.get('exploitation').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="societe">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="centrer"> Société </th>
          <td mat-cell  *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer no-padding">
              {{element.get('codeSociete').value}}
          </td>
        </ng-container>
        <ng-container matColumnDef="CA1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="centrer"> CA1 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
              {{element.get('codeCa1').value}}
          </td>
        </ng-container>
        <ng-container matColumnDef="visualiseBC">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text">Visualisation BC</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('visualiseBC').value" (change)="element.get('visualiseBC').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="createBc">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text">Création BC</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer" [matTooltip]="'Une destination doit être aussi selectionnée pour autoriser ce droit'">
            <mat-checkbox [checked]="element.get('createBc').value" (change)="element.get('createBc').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="livBc">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text">Livraison BC</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('livBc').value" (change)="element.get('livBc').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="valid1">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Validation 1 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('valid1').value" (change)="element.get('valid1').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="valid2">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Validation 2 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('valid2').value" (change)="element.get('valid2').setValue($event.checked)" [disabled]="onDisabled(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="valid3">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Validation 3 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('valid3').value" (change)="element.get('valid3').setValue($event.checked)" [disabled]="onDisabled(element) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="valid4">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Validation 4 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('valid4').value" (change)="element.get('valid4').setValue($event.checked)" [disabled]="onDisabled(element) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="valid5">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Validation 5 </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('valid5').value" (change)="element.get('valid5').setValue($event.checked)" [disabled]="onDisabled(element) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="importBCAValid">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Import BC </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('importBCAValid').value" (change)="element.get('importBCAValid').setValue($event.checked)" [disabled]="onDisabled(element) || element.get('codeCa1').value !== null">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="importBCProv">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text" > Import BC (reprise) </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('importBCProv').value" (change)="element.get('importBCProv').setValue($event.checked)" [disabled]="onDisabled(element) || (element.get('codeCa1').value !== null) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="genSage">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Interface SAGE </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('interfaceSage').value" (change)="element.get('interfaceSage').setValue($event.checked)" [disabled]="onDisabled(element) || (element.get('codeCa1').value !== null) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="userManager">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text">Gestion locale des utilisateurs</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('usersManager').value" (change)="element.get('usersManager').setValue($event.checked)" [disabled]="onDisabled(element) || (element.get('codeCa1').value !== null) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="repositoriesManager">
          <th mat-header-cell *matHeaderCellDef class="centrer area_text"> Admin Global </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer">
            <mat-checkbox [checked]="element.get('repositoriesManager').value" (change)="element.get('repositoriesManager').setValue($event.checked)" [disabled]="onDisabled(element) || (element.get('codeCa1').value !== null) || !hasDroitAdmin2(element.get('idSociete').value)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="centrer no-padding">
              <button mat-button (click)="onDeleteRow(element)" [disabled]="onDisabled(element)">
                <mat-icon color="red">delete</mat-icon>
              </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsDroit ;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumnsDroit;" [matTooltip]="row.get('messageRefus')?.value " [ngClass]="{'highlighted-row': isRowHighlighted(row)}"></tr>
      </table>
      <div class="footer">
        <mat-paginator #paginator [length]="this.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
            [pageSizeOptions]="[25, 50, 150]">
        </mat-paginator>
      </div>
    </form>
  </div>
</div>

